/**
 * Formats a tool-result cell value for display: nullish values render as an
 * em dash, booleans as German "Ja"/"Nein", and everything else as a string.
 */
function formatCellValue(value: unknown): string {
  if (value === null || value === undefined) {
    return "—";
  }

  if (typeof value === "boolean") {
    return value ? "Ja" : "Nein";
  }

  return String(value);
}

export { formatCellValue };
